<div class="ets-host-wrap">
  <div class="ets-root">
    <input
      #inputEl
      type="text"
      class="form-control input-sm ets-input"
      [attr.aria-expanded]="panelOpen"
      [attr.aria-autocomplete]="'list'"
      [placeholder]="placeholder"
      [disabled]="disabled"
      [ngModel]="displayText"
      (ngModelChange)="onInputChange($event)"
      (focus)="onFocus()"
      (blur)="onBlur()"
      (keydown.arrowDown)="onArrowDown($event)"
      (keydown.arrowUp)="onArrowUp($event)"
      (keydown.enter)="onEnter($event)"
      (keydown.escape)="onEscape($event)"
    />
    @if (!loading) {
<i
     
      class="fa fa-angle-down ets-chevron"
      aria-hidden="true"
      (mousedown)="clearAndOpen($event)"
    ></i>
}
    @if (loading) {
<div class="dd-loader ets-loader" aria-hidden="true">
      <i class="fa fa-spinner fa-spin"></i>
    </div>
}

    @if (panelOpen && !appendToBody) {
<div
     
      class="ets-dropdown-menu"
      role="listbox"
    >
      @for (item of filtered; track trackByIndex(i); let i = $index) {
<button
        type="button"
        class="ets-option"
       
        [class.active]="i === activeIndex"
        role="option"
        (mousedown)="$event.preventDefault(); selectItem(item)"
      >
        {{ getItemLabel(item) }}
      </button>
}
    </div>
}
  </div>

  @if (panelOpen && appendToBody) {
<div
   
    class="ets-dropdown-menu ets-dropdown-floating"
    role="listbox"
    [style.top.px]="panelTop"
    [style.left.px]="panelLeft"
    [style.width.px]="panelWidth"
  >
    @for (item of filtered; track trackByIndex(i); let i = $index) {
<button
      type="button"
      class="ets-option"
     
      [class.active]="i === activeIndex"
      role="option"
      (mousedown)="$event.preventDefault(); selectItem(item)"
    >
      {{ getItemLabel(item) }}
    </button>
}
  </div>
}
</div>
